import { createReducer, on, Action } from '@ngrx/store';
import { EntityState, createEntityAdapter, EntityAdapter } from '@ngrx/entity';
import * as InvoiceDocActions from '../_actions/invoiceDoc';
import { InvoiceDoc } from '../_models/invoiceDoc';

export interface InvoiceDocState extends EntityState<InvoiceDoc> {
  loading: boolean;
  error: any;
}

export const adapter: EntityAdapter<InvoiceDoc> = createEntityAdapter<InvoiceDoc>();

const initialState: InvoiceDocState = adapter.getInitialState({
  loading: false,
  error: null,
});

const invoiceDocReducer = createReducer(
  initialState,

  on(InvoiceDocActions.loadInvoiceDocs, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(InvoiceDocActions.loadInvoiceDocsSuccess, (state, { invoiceDocs }) =>
    adapter.setAll(invoiceDocs, { ...state, loading: false })
  ),

  on(InvoiceDocActions.loadInvoiceDocsFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  on(InvoiceDocActions.addInvoiceDocSuccess, (state, { invoiceDoc }) =>
    adapter.addOne(invoiceDoc, state)
  ),

  on(InvoiceDocActions.updateInvoiceDocSuccess, (state, { invoiceDoc }) =>
    adapter.upsertOne(invoiceDoc, state)
  ),

  on(InvoiceDocActions.deleteInvoiceDocSuccess, (state, { id }) => adapter.removeOne(id, state)),

  on(
    InvoiceDocActions.addInvoiceDocFailure,
    InvoiceDocActions.updateInvoiceDocFailure,
    InvoiceDocActions.deleteInvoiceDocFailure,
    (state, { error }) => ({
      ...state,
      error,
    })
  )
);

export function reducer(state: InvoiceDocState | undefined, action: Action) {
  return invoiceDocReducer(state, action);
}

export const { selectAll, selectEntities, selectTotal } = adapter.getSelectors();
